import React, {Component} from 'react';
import {build as WebAppBuild} from '../../package.json';
import {projectConfig} from '../../../shared/project-info/projectConfig';

export default class BuildInfo extends Component {
  render() {
    return (
      <div className="build-info" style={{display: 'none'}}>
        <div className="version">Version number {projectConfig.version}</div>
        <div className="build">Build number {WebAppBuild}</div>
      </div>
    );
  }
}
